<template>
  <div class="record-view">
    <div class="header">
      <img class="logo" src="@/assets/zs_imgs/ck-header-logo.png" alt="抽抽乐" />
      <span class="title">抽抽乐记录</span>
      <span class="subtitle">（总计抽卡{{ totalCount }}次）</span>
    </div>
    <div class="content">
      <el-scrollbar style="flex-grow: 1; height: 0;" wrapStyle="overflow-x: hidden;" viewStyle="padding-right: 126px;">
        <div class="star5-title">五星服饰</div>
        <div v-if="star5List.length === 0" class="empty-txt">无</div>
        <div v-else class="star5-grid">
          <div v-for="(item, index) in star5List" :key="index" class="item5">
            <div class="icon-box">
              <img class="sup" src="@/assets/zs_imgs/ck-role-border-sup.png" />
              <img class="icon" :src="item.icon_1" :alt="item.name" />
            </div>
            <div class="name">{{ item.name }}</div>
            <div class="count">{{ item.num }}抽</div>
          </div>
        </div>
        <div class="star4-title">四星服饰</div>
        <div v-if="star4List.length === 0" class="empty-txt">无</div>
        <div v-else class="star4-grid">
          <div v-for="(item, index) in star4List" :key="index" class="item4">
            <div class="icon-box">
              <img class="sup" src="@/assets/zs_imgs/ck-role-border-sup.png" />
              <img class="icon" :src="item.icon_1" :alt="item.name" />
              <div class="total">*{{ item.total_count }}</div>
            </div>
            <div class="name">{{ item.name }}</div>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import { apiCardPoolGachaCardResult } from "@/api/wiki-zsca";

export default {
  name: "RecordView",
  props: {
    currentNav: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      star4List: [],
      star5List: [],
      totalCount: 0
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      const { code, data } = await apiCardPoolGachaCardResult({ id: this.currentNav.id });
      if (code === 0) {
        this.star4List = data.result["4"] || [];
        this.star5List = data.result["5"] || [];
        this.totalCount = data.total_count;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.record-view {
  height: 100%;
  transform: translateZ(1px);
  position: relative;
  background: url("~@/assets/zs_imgs/ck-record-bg.png") center / cover no-repeat;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 0 20px 126px;
  z-index: 3;
  .header {
    height: 38px;
    margin: 22px 0 0 0;
    display: flex;
    align-items: center;
    .logo {
      width: 20px;
      height: 22px;
    }
    .title {
      color: #fff;
      font-size: 17px;
      font-weight: 500;
      margin-left: 4px;
    }
    .subtitle {
      font-size: 14px;
      color: #fff;
      position: relative;
      top: 2px;
    }
  }
  .content {
    flex-grow: 1;
    height: 0;
    overflow: auto;
    display: flex;
    flex-direction: column;
    .empty-txt {
      color: #fff;
      font-size: 14px;
      text-align: center;
      margin-top: 20px;
      line-height: 30px;
      text-align: left;
    }

    .star5-title {
      font-size: 16px;
      font-weight: 500;
      color: rgb(235, 192, 83);
      &:before {
        content: url("~@/assets/zs_imgs/ck-record-star5.png");
        margin-right: 6px;
      }
    }
    .star5-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, 92px);
      margin: 20px 0;
      gap: 30px 12px;
      justify-content: space-between;
      .item5 {
        width: 92px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
        .icon-box {
          position: relative;
          width: 72px;
          height: 72px;
          background: url("~@/assets/zs_imgs/ck-record-star5-border.png") center / contain no-repeat;
          .icon {
            width: 64px;
            height: 64px;
            margin: 4px;
            object-fit: contain;
            object-position: center;
            background-color: #3c372c;
            border-radius: 4px;
          }
          .sup {
            position: absolute;
            width: 20px;
            height: 20px;
            top: -5px;
            left: -5px;
          }
        }
        .name {
          color: rgb(244, 244, 244);
          font-size: 13px;
        }
        .count {
          text-align: center;
          color: #fff;
          width: 80px;
          height: 18px;
          line-height: 18px;
          font-size: 12px;
          background: url("~@/assets/zs_imgs/ck-record-count-bg.png") center / contain no-repeat;
        }
      }
    }
    .star4-title {
      font-size: 16px;
      font-weight: 500;
      color: rgb(216, 196, 255);
      margin-top: 20px;
      &:before {
        content: url("~@/assets/zs_imgs/ck-record-star4.png");
        margin-right: 6px;
      }
    }
    .star4-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, 92px);
      margin-top: 20px;
      gap: 30px 12px;
      justify-content: space-between;
      .item4 {
        width: 92px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
        .icon-box {
          position: relative;
          width: 72px;
          height: 72px;
          background: url("~@/assets/zs_imgs/ck-record-star4-border.png") center / contain no-repeat;
          .icon {
            width: 64px;
            height: 64px;
            margin: 4px;
            object-fit: contain;
            object-position: center;
            background-color: #3c372c;
            border-radius: 4px;
          }
          .sup {
            position: absolute;
            width: 20px;
            height: 20px;
            top: -5px;
            left: -5px;
          }
          .total {
            position: absolute;
            right: 2px;
            bottom: 2px;
            background-color: #655572;
            border-top-left-radius: 4px;
            color: #fff;
            font-size: 12px;
            padding: 2px 2px 0 2px;
            border-bottom-right-radius: 4px;
          }
        }
        .name {
          color: rgb(244, 244, 244);
          font-size: 13px;
        }
      }
    }
  }
}
</style>
